import Vue from 'vue'

export async function getCamino(context, [camino_id]) {
    try {
        const response = await Vue.axios({
            method: 'GET',
            url: '/getCamino/' + camino_id,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        context.commit('caminos/setCamino', response.data.data, { root: true })
        return response.data.data;
    } catch (e) {
        context.commit('caminos/setCamino', null, { root: true })
        return null;
    } finally {
    }
}

export async function getCaminoByReferencia(context, [camino_id]) {
    try {
        const response = await Vue.axios({
            method: 'GET',
            url: '/getCaminoByReferencia/' + camino_id,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        context.commit('caminos/setCamino', response.data.data, { root: true })
        return response.data.data;
    } catch (e) {
        context.commit('caminos/setCamino', null, { root: true })
        return null;
    } finally {
    }
}


export async function getCaminos(context) {
    try {
        const response = await Vue.axios({
            method: 'GET',
            url: '/getCaminos',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        context.commit('caminos/setCaminos', response.data.data, { root: true })
        return response.data.data;
    } catch (e) {
        context.commit('caminos/setCaminos', [], { root: true })
        return null;
    } finally {
    }
}

export async function getAgencias(context) {
    try {
        const response = await Vue.axios({
            method: 'GET',
            url: '/getAgencias',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        context.commit('caminos/setAgencias', response.data.data, { root: true })
        return response.data.data;
    } catch (e) {
        context.commit('caminos/setAgencias', [], { root: true })
        return null;
    } finally {
    }
}

export async function getAgencia(context, [agencia]) {
    try {
        const response = await Vue.axios({
            method: 'GET',
            url: '/getAgencia/' + agencia,  
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        context.commit('caminos/setAgencia', response.data.data, { root: true })
        return response.data.data;
    } catch (e) {
        context.commit('caminos/setAgencia', null, { root: true })
        return null;
    } finally {
    }
}

export async function createReserva(context, [camino, reserva, servicios, language]) {
    try {



        const response = await Vue.axios({
            method: 'POST',
            url: '/create-reserva',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: {
                camino_id: camino.id,
                
                nombre: reserva.cliente.nombre,
                apellidos: reserva.cliente.apellidos,
                telefono: reserva.cliente.telefono,
                email: reserva.cliente.email,

                fecha_inicio: reserva.fecha_inicio,
                fecha_llegada: reserva.fecha_llegada,
                codigo_agencia: reserva.codigo_agencia,
                cant_peregrinos: reserva.cant_peregrinos,
                cant_habitaciones_individuales: reserva.cant_habitaciones_individuales,
                cant_habitaciones_dobles: reserva.cant_habitaciones_dobles,
                cant_habitaciones_dobles_matrimoniales: reserva.cant_habitaciones_dobles_matrimoniales,
                cant_habitaciones_triples: reserva.cant_habitaciones_triples,
                tarifa_nocheextra_ind: reserva.tarifa_nocheextra_ind,
                tarifa_nocheextra_doble: reserva.tarifa_nocheextra_doble,
                tarifa_nocheextra_triple: reserva.tarifa_nocheextra_triple,
                comentarios: reserva.comentarios,
                origen_id: reserva.origen_id,
                importe_presupuestado: reserva.importe_presupuestado,
                importe_reserva: reserva.importe_reserva,
                importe_servicios: reserva.importe_servicios,
                descripcion_importe_reserva: reserva.descripcion_importe_reserva,
                descripcion_importe_servicios: reserva.descripcion_importe_servicios,
                descripcion_importe_presupuestado: reserva.descripcion_importe_presupuestado,
                language: language,
                servicios: servicios,
                acepta_politica: reserva.cliente.aceptaPolitica,
                acepta_novedades: reserva.cliente.aceptaNovedades ? 1 : 0,
                tiene_pendientes: reserva.tienePendientes ? 1 : 0,
                desgloce_nochesextras: reserva.desgloce_nochesextras,
                creada_por_id: reserva.creada_por_id,
                servicios_inc_cancelados: reserva.servicios_inc_cancelados 
            }
        })
        return response.data;
    } catch (e) {
        return null;
    } finally {
    }
}


export async function confirmarReserva(context, [camino, reserva, servicios, pasajeros, language]) {
    try {
        const response = await Vue.axios({
            method: 'POST',
            url: '/confirmar-reserva',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: {
                camino_id: camino.id,
                
                nombre: reserva.cliente.nombre,
                apellidos: reserva.cliente.apellidos,
                telefono: reserva.cliente.telefono,
                email: reserva.cliente.email,

                fecha_inicio: reserva.fecha_inicio,
                fecha_llegada: reserva.fecha_llegada,
                codigo_agencia: reserva.codigo_agencia,
                cant_peregrinos: reserva.cant_peregrinos,
                cant_habitaciones_individuales: reserva.cant_habitaciones_individuales,
                cant_habitaciones_dobles: reserva.cant_habitaciones_dobles,
                cant_habitaciones_dobles_matrimoniales: reserva.cant_habitaciones_dobles_matrimoniales,
                cant_habitaciones_triples: reserva.cant_habitaciones_triples,
                tarifa_nocheextra_ind: reserva.tarifa_nocheextra_ind,
                tarifa_nocheextra_doble: reserva.tarifa_nocheextra_doble,
                tarifa_nocheextra_triple: reserva.tarifa_nocheextra_triple,
                comentarios: reserva.comentarios,
                origen_id: reserva.origen_id,
                importe_presupuestado: reserva.importe_presupuestado,
                importe_reserva: reserva.importe_reserva,
                importe_servicios: reserva.importe_servicios,
                descripcion_importe_presupuestado: reserva.descripcion_importe_presupuestado,
                language: language,
                servicios: servicios,
                pasajeros: pasajeros,
                acepta_politica: reserva.cliente.aceptaPolitica,
                acepta_novedades: reserva.cliente.aceptaNovedades ? 1 : 0,
                desgloce_nochesextras: reserva.desgloce_nochesextras
            }
        })
        return response.data;
    } catch (e) {
        return null;
    } finally {
    }
}

export async function guardarDatosPasajeros(context, [reserva, pasajeros]) {
    const response = await Vue.axios({
        method: 'POST',
        url: '/guardar-datos-pasajeros',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        data: {
            reserva_id: reserva.id,
            version_pasajeros: reserva.version_pasajeros,
            codigo_agencia: reserva.codigo_agencia,
            pasajeros,
        }
    });
    return response.data;
}

export async function guardarAutorizacionTarjeta(context, [hash, autorizacion]) {
    try {
        const response = await Vue.axios({
            method: 'POST',
            url: '/guardar-autorizacion-tarjeta',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: {
                hash,
                ...autorizacion,
            }
        })
        return response.data;
    } catch (e) {
        return null;
    } finally {
    }
}


export async function getReservaByHash(context, [hash]) {
    try {
      const response = await Vue.axios({
        method: "GET",
        url: "/getReservaByHash?hash=" + hash,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data  
      ) {
        return response.data.data;
      } else {
        return null;
      }
  
    } catch (e) {
    } finally {
      context.commit("setLoading", false, { root: true });
    }
}

export async function getReservaEtapaProveedorByHash(context, [hash]) {
    try {
      const response = await Vue.axios({
        method: "POST",
        url: "/getReservaEtapaProveedorByHash",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          hash
        }
      });
      if (
        response && 
        response.status == 200 &&
        response.data 
      ) {
        return response.data;
      } else {
        return null;
      }
  
    } catch (e) {
    } finally {
      context.commit("setLoading", false, { root: true });
    }
}

export async function setEstadoReservaEtapaProveedor(context, [hash, accion, tarifa_ind, tarifa_doble, tarifa_triple, comentario]) {
    try {
        const response = await Vue.axios({
            method: "POST",
            url: "/setEstadoReservaEtapaProveedor",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            data: {
                hash,
                accion,
                tarifa_ind,
                tarifa_doble,
                tarifa_triple,
                comentario
            }
        });
        if (
            response &&
            response.status == 200 &&
            response.data
        ) {
            return response.data;
        } else {
            return null;
        }

    } catch (e) {
    } finally {
        context.commit("setLoading", false, { root: true });
    }
}
